__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.7.2-7c170ca-13325/_next/";